import { useEffect, useState } from "react";

import { CustomModal, FormError, TextInput, showToast } from "../shared";
import { useCreateTeam } from "../../lib/react-query/teams";

const CreateTeamModal = ({ isOpen, onClose }) => {
  const { mutateAsync: createTeam, isLoading } = useCreateTeam();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen) return;

    setName("");
    setDescription("");
    setError(null);
  }, [isOpen]);

  const handleCreate = async () => {
    try {
      const trimmedName = name.trim();
      const trimmedDescription = description.trim();

      if (!trimmedName) {
        setError("Team name is required.");
        return;
      }

      setError(null);

      await createTeam({
        name: trimmedName,
        description: trimmedDescription || undefined,
      });

      showToast("Team created successfully", "success", { position: "top-center" });
      onClose();
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.detail ||
        "Failed to create team.";
      setError(msg);
    }
  };

  return (
    <CustomModal
      title="Create team"
      open={isOpen}
      close={onClose}
      primaryButtonText="Create team"
      primaryButtonClick={handleCreate}
      primaryButtonLoading={isLoading}
      secondaryButtonText="Cancel"
      secondaryButtonClick={onClose}
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm leading-6 text-grey">
          Shared teams are for collaboration. Invite people, share projects, and manage the workspace together.
        </p>
        <TextInput
          label="Team name"
          name="name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder="Operations team"
          required
        />
        <TextInput
          label="Description"
          name="description"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          placeholder="What does this team work on?"
        />
        <FormError message={error} />
      </div>
    </CustomModal>
  );
};

export default CreateTeamModal;
